import { methodPostWithout } from './api/methods';

export const uploadFile = (data, token) => {
  return methodPostWithout('file/upload', data, token);
};
